import { createAxiosPlugin } from '../../../plugins/shared/axios.js';
/**
 * node/axios
 */
export const nodeAxios = createAxiosPlugin('node');
